import Vue from 'vue';
import { Inject } from 'vue-property-decorator';
import ComponentVue from 'vue-class-component';

import GlobalService, {
    GlobalSymbols, LocalizationStaticDictionary, ILocalizationService, LocalizationSymbols,
    IDateHandler, DateHandlerSymbols, BaseSystemLocalizationDictionary, Localization,
    formatDateIsoToRu, formatTimeIsoToRu, formatPrice
} from 'web-platform-help-desk-core-frontend-ui';

@ComponentVue
export default class WpBaseComponent<T extends BaseSystemLocalizationDictionary = BaseSystemLocalizationDictionary> extends Vue {
    _formatDateIsoToRu = formatDateIsoToRu;
    _formatTimeIsoToRu = formatTimeIsoToRu;
    _formatPrice = formatPrice;

    @Inject(GlobalSymbols.GlobalService)
    GlobalService!: GlobalService;

    Terms: T = {} as T;

    get DateHandler(): IDateHandler {
        return this.GlobalService.Get<IDateHandler>(DateHandlerSymbols.DateHandlerService);
    }

    get Locale(): Localization {
        return this.GlobalService.Get<ILocalizationService>(LocalizationSymbols.LocalizationService).CurrentLocalization;
    }

    constructor() {
        super();
        if (this.$options.name != null) {
            let localizationService = this.GlobalService.Get<ILocalizationService>(LocalizationSymbols.LocalizationService);
            let result = localizationService.GetStaticDictionary<T>(Symbol.for((<any>this.$options)._componentTag))
            if (result.Success && result.Data != null) {
                this.Terms = result.Data.Terms;
            }
        }
    }

}
